const internals = {};

exports.withRoutePermissions = (routes, options, inheritedDeniedRoleGroupIds = []) => {

    const {
        getCurrentRole,
        getRolePermissions,
        permissionDeniedRedirect = '/app/not-found'
    } = options;

    return [].concat(routes || []).map((route) => {

        if (!route) {
            return route;
        }

        const nextRoute = { ...route };
        const deniedRoleGroupIds = Array.from(new Set([
            ...inheritedDeniedRoleGroupIds,
            ...[].concat(nextRoute.deniedRoleGroupIds || [])
        ]));

        if (nextRoute.childRoutes) {
            nextRoute.childRoutes = exports.withRoutePermissions(
                nextRoute.childRoutes,
                options,
                deniedRoleGroupIds
            );
        }

        if (!nextRoute.requiredPermissions && !deniedRoleGroupIds.length) {
            return nextRoute;
        }

        const originalOnWillMount = nextRoute.onWillMount;
        const requiredPermissions = [].concat(nextRoute.requiredPermissions || []);
        const normalizedDeniedRoleGroupIds = deniedRoleGroupIds
            .map(internals.normalizeRoleGroupId)
            .filter((roleGroupId) => roleGroupId !== undefined);
        const permissionMode = nextRoute.requiredPermissionMode || 'all';

        nextRoute.onWillMount = async (routerProps) => {

            if (deniedRoleGroupIds.length) {
                const currentRole = getCurrentRole?.();
                const roleGroupId = internals.normalizeRoleGroupId(currentRole?.roleGroupId);

                if (roleGroupId === undefined || normalizedDeniedRoleGroupIds.includes(roleGroupId)) {
                    return {
                        replace: nextRoute.permissionDeniedRedirect || permissionDeniedRedirect
                    };
                }
            }

            const rolePermissions = getRolePermissions() || {};
            const hasRequiredPermissions = internals.hasRequiredPermissions({
                permissionMode,
                requiredPermissions,
                rolePermissions
            });

            if (!hasRequiredPermissions) {
                return {
                    replace: nextRoute.permissionDeniedRedirect || permissionDeniedRedirect
                };
            }

            if (originalOnWillMount) {
                return await originalOnWillMount(routerProps);
            }
        };

        return nextRoute;
    });
};

internals.normalizeRoleGroupId = (value) => {

    if (typeof value === 'string' && !/^\d+$/.test(value.trim())) {
        return undefined;
    }

    const roleGroupId = Number(value);

    return Number.isInteger(roleGroupId) && roleGroupId > 0
        ? roleGroupId
        : undefined;
};

internals.hasRequiredPermissions = ({ permissionMode, requiredPermissions, rolePermissions }) => {

    if (permissionMode === 'any') {
        return requiredPermissions.some((permissionName) => !!rolePermissions[permissionName]);
    }

    return requiredPermissions.every((permissionName) => !!rolePermissions[permissionName]);
};

if (process.env.NODE_ENV === 'test') {
    exports._internals = internals;
}
